import tokens from "../../../../../design-system/tokens.js";
import TruncatedName from "../../../../../design-system/components/TruncatedName/TruncatedName.jsx";

/**
 * Renders the team member names with customizable styles.
 *
 * @param {Object} options - The configuration options.
 * @param {Array} options.users - An array of user objects containing id and name.
 * @param {string} [options.color="gray200"] - The color of the team member names.
 * @param {boolean} [options.small=false] - Determines whether the names are small or not.
 * @returns {JSX.Element} The component that renders the team member names.
 */
export const TeamMemberNames = ({
  users,
  color = "gray200",
  small = false,
}) => {
  // The following constructs the style for the team member names.
  // It's not nice but I could not find a quick other solution for now.
  const spanStyle = {
    color: tokens.color.full[color],
  };
  if (small) {
    spanStyle.font = tokens.font.meta.medium;
  } else {
    spanStyle.font = tokens.font.body.default;
  }
  return (
    <span style={{ flexWrap: "wrap" }}>
      {users.map((u, idx) => (
        <span key={u.id} style={spanStyle}>
          <TruncatedName name={u.name} />
          {idx < users.length - 1 ? "," : ""}
        </span>
      ))}
    </span>
  );
};
